module.exports = __webpack_public_path__ + "static/media/M23ws.d4535507.pdf";